{
  "0_ALREADY_EXISTS": "“{0}” 已存在。",
  "0_OF_1": "{0} / {1}",
  "ACCOUNT_ID": "帳戶ID",
  "ADD": "添加",
  "ADD_REMOVE_FIELDS": "添加/移除欄位",
  "AN_ERROR_OCCURED": "發生錯誤",
  "APPLY": "應用",
  "APPLY_CHANGES": "應用更改",
  "ATTACH": "附加",
  "ATTACH_AS_LINK": "作為連結附加",
  "ATTACHING": "附加中...",
  "AUTOMATICALLY_RENAME": "自動重新命名",
  "BACK": "返回",
  "BROWSE": "流覽",
  "CANCEL": "取消",
  "CHARACTER_COUNT": "字元數：",
  "CLOSE": "關閉",
  "CLOUD": "Cloud",
  "COMMENT": "評論",
  "CONFIGURE_REPOSITORY_SETTINGS": "配置存儲庫設置",
  "COULD_NOT_SAVE_0": "無法保存「{0}」。",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "無法保存「{0}」。 檔類型不受支援。",
  "DATA": "數據",
  "DATE": "日期",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "日期欄位必須採用格式 {0}。",
  "DATE_PROVIDED_IS_INVALID": "提供的日期無效。",
  "DATE_TIME": "日期/時間",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "日期/時間欄位必須採用格式 {0}。",
  "DEFAULT_FOLDER": "<預設資料夾>",
  "DETAILS": "詳細資訊",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "您要應用欄位變更嗎？",
  "DOCUMENT_NAME_IS_EMPTY": "文件名稱為空",
  "DRAG_DROP_FILE": "拖放檔",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "此資料夾中已存在名為「{0}」的條目。 請選擇其他名稱。",
  "ENTRY_ID": "條目ID",
  "ENTRY_NAME": "條目名稱",
  "ENTRY_NOT_FOUND": "未找到條目。",
  "ERROR_DOWNLOADING_DOCUMENT": "下載文件時發生錯誤。",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "連接伺服器時發生錯誤。",
  "ERROR_SAVING": "儲存錯誤：",
  "FAILED_TO_OPEN_FOLDER": "打開資料夾失敗",
  "FAILED_TO_SAVE_COLON": "儲存失敗：",
  "FAILED_TO_SAVE_PERIOD": "保存失敗。",
  "FEEDBACK": "反饋",
  "FIELDS": "欄位",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "此文件超過最大檔大小 25MB。",
  "FILE_EXTENSION": "檔擴展名",
  "FILE_LOCKED": "檔已鎖定。",
  "FILE_MODIFIED": "檔已修改",
  "FILE_NAME": "檔名",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "檔名不能包含反斜杠",
  "FOLDER": "資料夾",
  "INTEGER": "整數",
  "LIST": "清單",
  "LOADING": "載入中...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "長字段必須是介於 0 到 3,999,999,999 之間的整數",
  "LONG_INTEGER": "長整數",
  "NAME": "名稱",
  "NAME_CONFLICT": "名稱衝突",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "需要登錄説明？ 請聯繫您的 Laserfiche 管理員。",
  "NEW_FOLDER": "新建資料夾",
  "NO": "否",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "未分配其他欄位",
  "NO_FOLDER_SELECTED": "未選擇資料夾。",
  "NO_MATCHING_ENTRIES_FOUND": "未找到匹配的條目",
  "NO_MATCHING_FIELDS_FOUND": "未找到匹配的欄位。",
  "NO_TEMPLATE_ASSIGNED": "未分配範本",
  "NOT_AVAILABLE_WITH_TOKENS": "令牌不可用",
  "NUMBER": "編號",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "數位欄位必須是有效數位",
  "OK": "確定",
  "ONE_OR_MORE_FIELDS_INVALID": "一個或多個字段無效。",
  "OPEN": "打開",
  "OPEN_IN_LASERFICHE": "在 Laserfiche 中打開",
  "OPTIONAL": "可選",
  "OR": "或",
  "PARENT_FIELD": "父欄位",
  "PARENT_ID": "父ID",
  "PARENT_NAME": "父名稱",
  "PLEASE_SELECT_A_FOLDER": "請選擇一個資料夾",
  "REASON_FOR_DOWNLOADING": "下載原因",
  "REFRESH": "刷新",
  "REMOVE": "拿掉",
  "REMOVE_REPOSITORY": "拿掉存儲庫？",
  "REPOSITORY": "Laserfiche Repository",
  "REPOSITORY_COUNT": "存儲庫計數",
  "REPOSITORY_ID": "存儲庫ID",
  "REPOSITORY_NAME": "存儲庫名稱",
  "REQUIRED": "必填",
  "REQUIRED_FIELD_IS_EMPTY": "必填欄位為空",
  "SAVE_CHANGES": "保存更改",
  "SAVE_TO_LASERFICHE": "保存到 Laserfiche",
  "SAVED_TO_LASERFICHE": "已保存到 Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "已保存到 Laserfiche：",
  "SAVED_WITH_MISSING_METADATA": "儲存時缺少元資料：",
  "SAVING": "儲存中...",
  "SEARCH_FIELDS": "搜索欄位",
  "SELECT": "選擇",
  "SELECT_REASON": "選擇原因",
  "SELF_HOSTED": "自託管",
  "SESSION_COUNT": "會話計數",
  "SETTINGS": "設置",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "短字段必須是介於 0 到 64999 之間的整數",
  "SIGN_IN": "登錄",
  "SIGN_IN_TO_LASERFICHE": "登錄 Laserfiche",
  "SIGN_OUT": "註銷",
  "SIGNING_IN": "登入...",
  "SIGNING_OUT": "登出...",
  "SKIP_THIS_FILE": "跳過此檔",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "出現問題。 請稍後再試。",
  "SUBMIT": "提交",
  "SUGGESTION": "建議",
  "TEMPLATE": "範本",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "範本載入失敗。",
  "TEXT": "文本",
  "THANK_YOU_FOR_SUBMISSION": "感謝您的提交！",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "此欄位的最大允許長度為 {0} 個字元。",
  "THIS_FOLDER_IS_EMPTY": "此資料夾為空。",
  "TIME": "時間",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "時間欄位必須採用格式 {0}。",
  "UNABLE_TO_LOAD_ALL_FIELDS": "無法載入所有欄位：",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "無法檢索儲存庫資訊：",
  "UNKNOWN_ERROR": "未知錯誤。",
  "USER_NAME": "使用者名",
  "YES": "是"
}
